import { Tooltip, type TooltipProps } from "antd";
import { useTranslation } from "react-i18next";

interface DeliveryTooltipProps {
  text?: string;
  children: React.ReactNode;
  placement?: TooltipProps["placement"];
  tooltipOffset?: number[];
  content?: any;
}

const CustomTooltip = ({
  text,
  children,
  placement = "bottomRight",
  content = "",
}: DeliveryTooltipProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={text ? t(text) : content}
      placement={placement}
      arrow={false}
      overlayInnerStyle={{
        padding: "1.2rem",
        fontSize: "1.4rem",
        color: "black",
        backgroundColor: "#fff",
        borderRadius: "4px",
        lineHeight: "2.4rem",
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.15)",
        width: "28.3rem",
        display: "flex",
      }}>
      {children}
    </Tooltip>
  );
};

export default CustomTooltip;
